import React from 'react';
import styled from 'styled-components';

import { Button } from '@makeship/core';
import Modal from '..';
import { H5, P2 } from '../../Typography';
import { modalTheme } from '../../../styles/themes';

const MODAL_TEXT =
  'Receive a unique Edition Badge with every Campaign you support! The Edition number is revealed at the end of a successful Campaign.';

const ModalContent = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 32px;
  }
`;

const ModalHeader = styled.div`
  text-align: center;
  margin-top: 16px;
  margin-bottom: 32px;
  & > * + * {
    margin-top: 16px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    margin-top: 0;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

type BadgesModalProps = {
  isOpen: boolean;
  closeModal: () => void;
};

const BadgesModal: React.FC<BadgesModalProps> = ({ isOpen, closeModal }: BadgesModalProps) => (
  <Modal isOpen={isOpen} onRequestClose={closeModal} theme={modalTheme}>
    <ModalContent>
      <ModalHeader>
        <H5>You discovered Makeship Badges!</H5>
        <P2>{MODAL_TEXT}</P2>
      </ModalHeader>
      <ButtonWrapper>
        <Button.Primary onClick={closeModal}>Got it!</Button.Primary>
      </ButtonWrapper>
    </ModalContent>
  </Modal>
);

export default BadgesModal;
